import { Component, ContentChildren, EventEmitter, Output, QueryList, ChangeDetectionStrategy } from '@angular/core';
import { WizardFormDirective } from './wizard-form.directive';

@Component({
    selector: 'ceres-wizard',
    templateUrl: './wizard.component.html',
    styleUrls: ['./wizard.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WizardComponent {
    @ContentChildren(WizardFormDirective)
    wizardForms!: QueryList<WizardFormDirective>;

    @Output() save = new EventEmitter<void>();

    @Output() cancel = new EventEmitter<void>();
}
